import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { LogOut, LayoutDashboard, LogIn } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const isPublicHome = loc.pathname === "/";

  const dashboardHref =
    user && user.role === "admin" ? "/admin"
    : user && user.role === "buyer" ? "/buyer"
    : user && user.role === "fpo" ? "/fpo"
    : "/login";

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="sticky top-0 z-40 backdrop-blur bg-background/85 border-b border-border/70">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
            <div className="w-9 h-9 rounded-full bg-primary text-primary-foreground grid place-items-center font-heading font-bold">G</div>
            <div className="font-marketing text-2xl leading-none text-foreground">
              Gudlink
            </div>
            <span className="hidden sm:inline text-[10px] tracking-[0.25em] uppercase text-muted-foreground ml-1">Traceability</span>
          </Link>
          <nav className="flex items-center gap-2 sm:gap-3">
            {isPublicHome && (
              <a href="#how" className="hidden md:inline text-sm text-muted-foreground hover:text-foreground transition-colors">How it works</a>
            )}
            {isPublicHome && (
              <a href="#users" className="hidden md:inline text-sm text-muted-foreground hover:text-foreground transition-colors">For whom</a>
            )}
            {user ? (
              <>
                <Button asChild variant="ghost" size="sm" data-testid="nav-dashboard-btn">
                  <Link to={dashboardHref}><LayoutDashboard className="h-4 w-4 mr-1"/>Dashboard</Link>
                </Button>
                <Button variant="outline" size="sm" onClick={async () => { await logout(); nav("/"); }} data-testid="nav-logout-btn">
                  <LogOut className="h-4 w-4 mr-1"/>Logout
                </Button>
              </>
            ) : (
              <>
                <Button asChild variant="ghost" size="sm" data-testid="nav-login-btn">
                  <Link to="/login"><LogIn className="h-4 w-4 mr-1"/>Login</Link>
                </Button>
                <Button asChild size="sm" className="bg-primary hover:bg-primary/90" data-testid="nav-register-btn">
                  <Link to="/register">Join Gudlink</Link>
                </Button>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
      <footer className="border-t border-border/70 py-8 mt-16 text-sm text-muted-foreground">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row justify-between gap-4">
          <div>
            <div className="font-marketing text-xl text-foreground">Gudlink</div>
            <p className="mt-1 max-w-md">The global trust mark for authentic Indian jaggery. Starting from Kolhapur — built for every jaggery-making region of India.</p>
          </div>
          <div className="text-xs tracking-[0.2em] uppercase">© {new Date().getFullYear()} · Pilot in Kolhapur · For all of India</div>
        </div>
      </footer>
    </div>
  );
}
